export function formatNumbers(value) {
  const number = Number(value);

  if (isNaN(number)) return "0";

  return number.toLocaleString(); // Nigerian locale with commas
}
